import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import { useTarifariosErroresEmpresaMantenedor } from '../../hooks/useTarifariosErroresEmpresaMantenedor';
import ErroresTarifariosEmpresaDetalleComponent from '../../components/Tarifarios/ErroresTarifariosEmpresaDetalleComponent';

const ErroresTarifariosEmpresaPage = () => {
    const history = useHistory();
    const user = useSelector(state => state.auth.user);
    const { userPermissions } = useMantenedores();
    const permisos = userPermissions?.modules?.tarifarios || {};

    const {
        detalleErrores,
        loading,
        error,
        regionId,
        regiones,
        handleRegionChange,
        handleSavePrecios,
        savingPrecios
    } = useTarifariosErroresEmpresaMantenedor(user, permisos);

    const handleBack = () => {
        history.push('/mantenedores/tarifarios/errores');
    };

    return (
        <SimpleMantenedorLayout
            mantenedorId="tarifarios"
            title="Errores de Empresa"
            subtitle="Corrección masiva de precios de empresa faltantes"
            iconColor="#dc3545"
            showBackButton={false}
            backButtonPath="/mantenedores/tarifarios/errores"
            breadcrumbs={[
                {
                    label: 'Tarifarios',
                    path: '/mantenedores/tarifarios'
                },
                {
                    label: 'Errores de Tarifario',
                    path: '/mantenedores/tarifarios/errores'
                },
                {
                    label: 'Errores de Empresa'
                }
            ]}
        >
            {error && <div className="alert alert-danger mb-2">{error}</div>}
            
            <ErroresTarifariosEmpresaDetalleComponent
                detalleErrores={detalleErrores}
                loading={loading}
                regionId={regionId}
                regiones={regiones}
                onRegionChange={handleRegionChange}
                onSavePrecios={handleSavePrecios}
                savingPrecios={savingPrecios}
                onBack={handleBack}
            />
        </SimpleMantenedorLayout>
    );
};

export default ErroresTarifariosEmpresaPage;
